<script setup>
import { noteItems, noteDisclaimer } from '../../config/pageData.js';
</script>

<template>
  <section class="m-sec m-sec-paper2">
    <div class="m-center">
      <span class="m-kicker">正 式 課 體 系</span>
    </div>
    <h2 class="m-title">公開課只係開始，正式課仲有成套實修筆記</h2>
    <p class="m-sub">以下節錄自正式課學員嘅實修教材——由觀想、持咒到請動，一步步有圖有法可依。</p>
    <div class="m-notes">
      <div
        v-for="(item, i) in noteItems"
        :key="i"
        class="m-note-card"
      >
        <img
          :src="item.image"
          :alt="item.cap"
          class="m-note-img"
          loading="lazy"
        />
        <div class="m-note-cap">{{ item.cap }}</div>
        <div class="m-note-sub">{{ item.sub }}</div>
      </div>
    </div>
    <p class="m-note-disclaimer">{{ noteDisclaimer }}</p>
  </section>
</template>

<style scoped lang="scss">
.m-sec {
  padding: 96px 32px;
}

.m-sec-paper2 {
  background: #efe8d8;
}

.m-center {
  text-align: center;
}

.m-kicker {
  display: inline-block;
  font-size: 24px;
  letter-spacing: 8px;
  color: #a8823f;
  border: 2px solid #c9a25e;
  padding: 8px 24px;
  border-radius: 999px;
  margin-bottom: 24px;
}

.m-title {
  font-size: 44px;
  font-weight: 700;
  line-height: 1.4;
  text-align: center;
  color: #16241d;
  letter-spacing: 1px;
}

.m-sub {
  text-align: center;
  color: #6f6a5c;
  font-size: 26px;
  margin-top: 18px;
}

.m-notes {
  display: flex;
  gap: 24px;
  margin-top: 44px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
}

.m-note-card {
  flex: 0 0 78%;
  scroll-snap-align: center;
  background: #fff;
  border: 1px solid #e7dfcc;
  border-radius: 18px;
  padding: 18px 18px 24px;
  text-align: center;
}

.m-note-img {
  width: 100%;
  border-radius: 12px;
  display: block;
}

.m-note-cap {
  margin-top: 16px;
  font-size: 28px;
  font-weight: 700;
  color: #16241d;
}

.m-note-sub {
  margin-top: 6px;
  font-size: 22px;
  color: #6f6a5c;
}

.m-note-disclaimer {
  margin-top: 24px;
  text-align: center;
  font-size: 22px;
  color: #6f6a5c;
}
</style>
